package com.nonopn.skywatcher.config

import com.nonopn.skywatcher.config.buildconfig.BuildKonfig

object SharedConfig {
    val googleAuthServerId = BuildKonfig.googleAuthServerId
    val openWeatherMapApiKey = BuildKonfig.openWeatherMapApiKey
    val sentryClient = BuildKonfig.sentryClient
    val sentrySecondary = BuildKonfig.sentrySecondary
    val version = BuildKonfig.version
}
